module.exports = __webpack_public_path__ + "static/media/redeem-step-1.6e317046.svg";